import { eIconType } from "../../features/common"
import { IGameScenario } from "../../features/map_draft/api_entities"
import { useAllScenariosQuery } from "../../services/MapClientAPI"
import { getSpriteLink, printMultilangString } from "../../services/utils"
//import { RootState } from "../../store"
import { useDispatch, useSelector } from 'react-redux'
import { IDisplayMode, setLanguage, setScenario } from "../../features/displayMode"
import { RootState } from "../../store"

export interface IModelSelectProps
{
    activeLang: string
}

function getModeClassName(displayMode:IDisplayMode, item:IGameScenario){
    var res:string = ""
    if(item.id === displayMode.selected_scenario)
    {
        res = "scenario-item--active"
    }
    else
    {
        res = "scenario-item";
    }
    if(item.is_enabled === true)
    {
        res += " enabled"
    }
    else
    {
        res += " disabled"
    }
    return res;
}

function ModeSelect({activeLang}:IModelSelectProps) {

    const {data, /*error,*/ isLoading} = useAllScenariosQuery()
    const displayMode = useSelector((state:RootState) => state.displayMode)
    
    const dispatch = useDispatch()
     
    if(isLoading){
        return (<div></div>)
    }
  
    return <div className="interactive-map__mode">
            <div className={activeLang==='ru' ? 'maplang--active': 'maplang'}
            onClick={() => dispatch(setLanguage('ru'))}>
                <img src={getSpriteLink(eIconType.MapMenuBg,'lang_ru')} alt="lang"/>
            </div>
            <div className={activeLang==='en' ? 'maplang--active': 'maplang'}
            onClick={() => dispatch(setLanguage('en'))}>
                <img src={getSpriteLink(eIconType.MapMenuBg,'lang_en')} alt="lang"/>
            </div>
            {data?.map((item:IGameScenario)=>{
                return(<div className={getModeClassName(displayMode, item)} 
                key={item.id} onClick={item.is_enabled ? () => {dispatch(setScenario(item.id))}: () => {}}>{printMultilangString(item.title, activeLang)}</div>)
            })}
    </div>
}

export default ModeSelect